import React from 'react';
import PropTypes from 'prop-types';

import ButtonAction from 'components/ButtonAction';
import ToggleButton from 'components/ToggleButton';
import withAuthorization from 'hocs/withAuthorization';

const buttons = [
	{
		icon: 'heart',
		title: 'Добавить в избранное',
		type: 'favorite'
	},
	{
		icon: 'checkBold',
		title: 'Убрать из избранного',
		type: 'favorite',
		active: true
	}
];

const FavoritesButton = ({ isFavorite, onClick, onAuthorizationRequest }) => {
	const WrappedToggleButton = withAuthorization({
		text: 'Авторизуйтесь на портале, чтобы добавить трансляцию в избранное.',
		onButtonClick: onAuthorizationRequest
	})(ToggleButton);

	return (
		<WrappedToggleButton
			ButtonComponent={ButtonAction}
			buttons={buttons}
			onClick={onClick}
			activePrimaryButton={!isFavorite}
		/>
	);
};

FavoritesButton.propTypes = {
	isFavorite: PropTypes.bool,
	onClick: PropTypes.func,
	onAuthorizationRequest: PropTypes.func
};

export default FavoritesButton;
